(function newProdSubscriptionCta() {
  const ctaByOption = {
    starter: {
      subscribe: { action: 'Subscribe', price: '$49.00', compare: '' },
      oneTime: { action: 'Checkout', price: '$49.00', compare: '' }
    },
    complete: {
      subscribe: { action: 'Subscribe', price: '$111.00', compare: '$147.00 AUD' },
      oneTime: { action: 'Checkout', price: '$147.00', compare: '' }
    },
    double: {
      subscribe: { action: 'Subscribe', price: '$210.00', compare: '$294.00 AUD' },
      oneTime: { action: 'Checkout', price: '$294.00', compare: '' }
    }
  };

  function selectedOptionKey() {
    const selected = document.querySelector('.new-prod-subscription__option.is-selected');
    return selected && selected.dataset.newProdOption ? selected.dataset.newProdOption : 'complete';
  }

  function selectedPurchaseMode() {
    const selected = document.querySelector('.new-prod-subscription__tabs button.is-selected');
    return selected && selected.dataset.newProdPurchase === 'one-time' ? 'oneTime' : 'subscribe';
  }

  function textSpan(text, className) {
    const span = document.createElement('span');
    if (className) span.className = className;
    span.textContent = text;
    return span;
  }

  function syncCta() {
    const subscriptionUi = document.querySelector('.new-prod-subscription');
    const button = document.querySelector('[data-add-to-cart]');
    const addText = document.querySelector('[data-add-to-cart-text]');
    if (!subscriptionUi || !button || !addText || button.disabled) return false;

    const option = ctaByOption[selectedOptionKey()] || ctaByOption.complete;
    const cta = option[selectedPurchaseMode()] || option.subscribe;
    const main = textSpan('', 'new-prod-atc-main');

    main.append(
      textSpan(cta.action),
      textSpan('•'),
      textSpan(cta.price)
    );

    addText.classList.add('new-prod-atc-text');
    addText.textContent = '';
    addText.append(main);

    if (cta.compare) {
      addText.append(textSpan(cta.compare, 'new-prod-atc-compare'));
    }

    addText.setAttribute(
      'aria-label',
      `${cta.action} ${cta.price}${cta.compare ? ` was ${cta.compare}` : ''}`
    );
    return true;
  }

  function scheduleSync() {
    requestAnimationFrame(syncCta);
    window.setTimeout(syncCta, 60);
  }

  document.addEventListener('DOMContentLoaded', function() {
    let attempts = 0;
    const timer = window.setInterval(function() {
      // Stop polling as soon as the CTA is populated; the click/change
      // listeners below will keep it in sync after user interactions.
      if (syncCta()) {
        window.clearInterval(timer);
        return;
      }
      attempts += 1;
      if (attempts > 48) window.clearInterval(timer);
    }, 100);

    scheduleSync();
  });

  document.addEventListener('click', function(event) {
    if (event.target.closest('.new-prod-subscription')) {
      scheduleSync();
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.closest('.product__form') || event.target.closest('.kaching-bundles__block')) {
      scheduleSync();
    }
  });
})();
